import { render, staticRenderFns } from "./Defects.vue?vue&type=template&id=20789532&scoped=true&"
import script from "./Defects.vue?vue&type=script&lang=js&"
export * from "./Defects.vue?vue&type=script&lang=js&"
import style0 from "./Defects.vue?vue&type=style&index=0&id=20789532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20789532",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VSelect,VTextField})
